export default __webpack_public_path__ + "static/media/IBMCloudActive.c8c5f8d7.svg";